import { style } from '@/styles/globals';
import { Stack, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';

const SeoNoteLine = ({ message, sx }: { message: string, sx?: React.CSSProperties }) => (
  <Stack
    direction="row"
    spacing="0.5em"
    padding="1em"
    sx={{
      bgcolor: style.color.blue4,
      borderRadius: '6px',
      ...sx,
    }}
  >
    <ErrorIcon
      sx={{
        fontSize: '1.3rem',
        mt: '2px',
      }}
      htmlColor={style.color.blue2}
    />
    <Typography
      variant="body2"
      color={style.color.blue2}
    >
      {message}
    </Typography>
  </Stack>
);

export default SeoNoteLine;
